import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-74828d64")
const _hoisted_1 = { class: "setting-name" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = {
  key: 0,
  class: "description"
}
const _hoisted_4 = { class: "setting-controller" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["setting", { disabled: _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.name), 1),
      (_ctx.description !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}